import { render, staticRenderFns } from "./ProfileLinks.vue?vue&type=template&id=721020a3&scoped=true&"
import script from "./ProfileLinks.vue?vue&type=script&lang=js&"
export * from "./ProfileLinks.vue?vue&type=script&lang=js&"
import style0 from "./ProfileLinks.vue?vue&type=style&index=0&id=721020a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721020a3",
  null
  
)

export default component.exports